// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".associated_customer[data-v-0c2fec9a] {\n  /*height: 50vh;*/\n}\n.associated_customer .associated_customer_line[data-v-0c2fec9a] {\n  height: 2px;\n  width: 100%;\n  background-color: #aaa;\n  margin: 30px 0;\n}\n.associated_customer .footer-btn[data-v-0c2fec9a] {\n  position: absolute;\n  bottom: 0;\n  right: 10px;\n}\n.associated_customer .footer-btn button[data-v-0c2fec9a] {\n  width: 100px;\n}\n", ""]);
// Exports
module.exports = exports;
